import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { RoutingService } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { MyCompanyService } from './my-company.service';

@Component({
  selector: 'app-my-company',
  templateUrl: './my-company.component.html',
  styleUrls: ['./my-company.component.scss']
})
export class MyCompanyComponent implements OnInit {
  userData: any;
  constructor(
    protected service: MyCompanyService,
    protected routingService: RoutingService,
    private userAccount: UserAccountFacade,
    public cdf: ChangeDetectorRef
  ) {

  }
  organizationData: any = {
    'orgId': '',
    'orgName': '',
    'orgAddress': ''
  };


  ngOnInit(): void {
    this.userAccount.get().subscribe((resp) => {
      if (resp) {
        this.service.getMyCompany({}, resp).subscribe(
          (response: any) => {
            if (response) {
              let that = this;
              console.log(this);
              that.organizationData.orgId = response.uid;
              that.organizationData.orgName = response.name;
              that.organizationData.orgAddress = response.billingAddress.formattedAddress;
              this.cdf.detectChanges();
              console.log('xxx', that.organizationData);
            }
          },
          () => { }
        )
      }
    })
  }
}
